import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Antud toote puhul on tegemist eritellimusega ja tootele ei kehti 14 päevane tagastusõigus

  <span style="color:#85c1dc;">**FI:**</span>
  Tämä tuote on erikoistilaus eikä tuotteella ole 14 päivän palautusoikeutta

  <span style="color:#85c1dc;">**RU:**</span>
  Этот продукт является специальным заказом, и продукт не имеет права на возврат в течение 14 дней.
*/
/* @__NO_SIDE_EFFECTS__ */
const m874 = msg(
  mf`Antud toote puhul on tegemist eritellimusega ja tootele ei kehti 14 päevane tagastusõigus`,
  mf`Tämä tuote on erikoistilaus eikä tuotteella ole 14 päivän palautusoikeutta`,
  mf`Этот продукт является специальным заказом, и продукт не имеет права на возврат в течение 14 дней.`,
)

export { m874 as 'w.module.product_description.special_order' }